import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { useClickAway } from 'react-use';

import { type Company } from 'modules/app/hooks/useCompany';
import CONFIG from 'src/core/config';

import './GringottsIframe.css';

export type GringottsNavigation = {
  path: 'card-purchase';
  params: {
    cardId: string;
    amount?: number;
    currency?: string;
    supplierName: string | null;
  };
};
interface Props {
  companyId: string;
  bankingProvider: Company['banking_provider'];
  onClose(): void;
  navigation?: GringottsNavigation;
}

export interface GringottsConfig {
  companyId: string;
  bankingProvider: string;
  navigation?: GringottsNavigation;
}

const buildGringottsUrl = (
  companyId: string,
  bankingProvider: Company['banking_provider'],
  gringottsBaseUrl: string,
  apiBaseUrl: string,
  navigation?: GringottsNavigation,
): string => {
  let path = '/';
  const params: Record<string, string> = {
    companyId,
    bankingProvider: bankingProvider || '',
    apiBaseUrl: encodeURIComponent(apiBaseUrl),
  };

  if (navigation) {
    switch (navigation.path) {
      case 'card-purchase':
        path = '/card-purchase';
        params.cardId = navigation.params.cardId;

        if (navigation.params.amount !== undefined) {
          params.amount = navigation.params.amount.toString();
        }
        if (navigation.params.currency) {
          params.currency = navigation.params.currency;
        }
        if (navigation.params.supplierName) {
          params.supplierName = navigation.params.supplierName;
        }
        break;
      default:
        path = '/';
    }
  }

  const searchParams = new URLSearchParams(params);
  return `${gringottsBaseUrl}${path}?${searchParams.toString()}`;
};

export const GringottsIframe = ({
  companyId,
  bankingProvider,
  onClose,
  navigation,
}: Props) => {
  const iframeReference = useRef(null);
  useClickAway(iframeReference, () => onClose());

  const apiBaseUrl = CONFIG.apiUrls.api;

  const { gringottsBaseUrl } = CONFIG;

  const gringottsUrl = buildGringottsUrl(
    companyId,
    bankingProvider,
    gringottsBaseUrl,
    apiBaseUrl,
    navigation,
  );

  return ReactDOM.createPortal(
    <iframe
      ref={iframeReference}
      title="gringotts"
      src={gringottsUrl}
      className="GringottsIframe"
    />,
    document.body,
  );
};
